import { useNavigate } from 'react-router-dom'
import {
  Buildings,
  Heartbeat,
  MapPin,
  Student,
  Globe,
} from '@phosphor-icons/react'

import { useLang } from '../../context/LangContext'
import { useSite, SITES } from '../../context/SiteContext'
import LangToggle from '../../components/LangToggle/LangToggle'

const SITE_ICONS = {
  'building-community':  Buildings,
  'heart-rate-monitor':  Heartbeat,
  'map-pin':             MapPin,
  'student':             Student,
}

export default function SiteSelectPage() {
  const { t } = useLang()
  const { setSite } = useSite()
  const navigate = useNavigate()

  const handleSelect = (site) => {
    setSite(site)
    navigate('/login')
  }

  return (
    <div className="public-page">
      <div className="public-page__topbar">
        <div className="public-page__brand">
          <div className="sidebar__logo-icon"><span>HD</span></div>
          <span className="public-page__brand-name">HelpDesk System</span>
        </div>
        <LangToggle />
      </div>

      <div className="public-page__body">
        <div className="site-select">
          <div className="site-select__header">
            <Globe size={36} className="site-select__globe" />
            <h1 className="site-select__title">{t('chooseSite')}</h1>
            <p className="site-select__subtitle">{t('siteSubtitle')}</p>
          </div>

          <div className="site-select__grid">
            {SITES.map((site) => {
              const Icon = SITE_ICONS[site.icon] ?? Buildings
              return (
                <button
                  key={site.id}
                  className="site-card"
                  onClick={() => handleSelect(site)}
                >
                  <div className={`site-card__icon site-card__icon--${site.colorClass}`}>
                    <Icon size={22} />
                  </div>
                  <div className="site-card__name">{site.name}</div>
                  <div className="site-card__desc">{site.description}</div>
                </button>
              )
            })}
          </div>

          <p className="site-select__footer">
            {t('noSite')}{' '}
            <span className="link">{t('contactAdmin')}</span>
          </p>
        </div>
      </div>
    </div>
  )
}
